import React, { Fragment, useState } from 'react';
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Button, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ContractModal from './ContractModal';
import moment from 'moment';
import { DELETE, provider } from '../../../_utils';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Utils from '../utils';

const contractsFromOperator = (data) => {
    if (Array.isArray(data?.contracts)) return data.contracts;
    if (Array.isArray(data?.contract)) return data.contract;
    if (data?.contract && typeof data.contract === 'object') return [data.contract];
    return [];
};

const OperatorContracts = ({ data, classes, onDataUpdate }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedContract, setSelectedContract] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    const operatorId = data?._id || data?.id;
    const contracts = contractsFromOperator(data);

    const handleAddClick = () => {
        setSelectedContract(null);
        setIsEditing(true);
        setModalOpen(true);
    };

    const handleEditClick = (contract) => {
        setSelectedContract(contract);
        setIsEditing(true);
        setModalOpen(true);
    };

    const handleDeleteClick = async (contract) => {
        if (!window.confirm('Вы уверены, что хотите удалить этот контракт?')) {
            return;
        }

        try {
            const contractId = contract._id || contract.id;
            if (!contractId) {
                alert('Ошибка: не найден ID контракта');
                return;
            }

            const { status } = await provider(
                DELETE,
                '/contracts',
                contractId
            );

            if (status >= 200 && status < 300) {
                if (onDataUpdate) onDataUpdate();
            }
        } catch (error) {
            console.error('Error deleting contract:', error);
            alert('Ошибка при удалении контракта');
        }
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedContract(null);
        setIsEditing(false);
    };

    const handleSaveModal = async () => {
        if (onDataUpdate) onDataUpdate();
        handleCloseModal();
    };

    const formatDate = (date) => {
        if (!date) return '-';
        return moment(date).format('DD.MM.YYYY');
    };

    const getContractTypeLabel = (type) => {
        const types = {
            'Contract': 'Контракт',
            'Contractor': 'Подряд'
        };
        return types[type] || type;
    };

    const isActive = (contract) => {
        if (!contract.end) return true; // Если нет даты окончания, считаем активным
        const endDate = new Date(contract.end);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return endDate >= today;
    };

    const getParttimeLabel = (parttime) => {
        if (!parttime) return '-';
        const { parttimeTypes } = Utils.options();
        const parttimeOption = parttimeTypes.find(pt => pt.id === parttime);
        return parttimeOption ? parttimeOption.name : parttime;
    };

    return (
        <div>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography className={classes.sectionTitle}>
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={handleAddClick}
                >
                    Добавить
                </Button>
            </Box>
            {contracts.length === 0 ? (
                <Typography style={{ color: '#666', fontSize: '14px', marginTop: 8 }}>
                    Нет контрактов
                </Typography>
            ) : (
                <TableContainer component={Paper} className={classes.paySheetTable}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.paySheetTableHeader}>Тип</TableCell>
                                <TableCell className={classes.paySheetTableHeader}>Номер</TableCell>
                                <TableCell className={classes.paySheetTableHeader}>Начало</TableCell>
                                <TableCell className={classes.paySheetTableHeader}>Окончание</TableCell>
                                <TableCell className={classes.paySheetTableHeader} align="center">Статус</TableCell>
                                <TableCell className={classes.paySheetTableHeader} align="center">Ставка</TableCell>
                                <TableCell className={classes.paySheetTableHeader} align="center">Действия</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {contracts.map((contract) => (
                                <TableRow key={contract._id || contract.id} hover>
                                    <TableCell className={classes.paySheetTableCell}>
                                        {getContractTypeLabel(contract.type)}
                                    </TableCell>
                                    <TableCell className={classes.paySheetTableCell}>
                                        {contract.number || '-'}
                                    </TableCell>
                                    <TableCell className={classes.paySheetTableCell}>
                                        {formatDate(contract.start)}
                                    </TableCell>
                                    <TableCell className={classes.paySheetTableCell}>
                                        {formatDate(contract.end)}
                                    </TableCell>
                                    <TableCell className={classes.paySheetTableCell} align="center">
                                        <div className={classes.statusField}>
                                            {isActive(contract) ?
                                                <Fragment>
                                                    <div className={classes.statusFieldSucces}>
                                                        <CheckIcon size="small" />
                                                    </div>
                                                    <div className={classes.statusFieldLabel} style={{color: "#4CAF50"}}>
                                                        Активен
                                                    </div>
                                                </Fragment>
                                            :
                                                <Fragment>
                                                    <div className={classes.statusFieldError}>
                                                        <CloseIcon size="small" />
                                                    </div>
                                                    <div className={classes.statusFieldLabel} style={{color: "#ec716a"}}>
                                                        Завершен
                                                    </div>
                                                </Fragment>
                                            }
                                        </div>
                                    </TableCell>
                                    <TableCell className={classes.paySheetTableCell} align="center">
                                        {getParttimeLabel(contract.parttime)}
                                    </TableCell>
                                    <TableCell className={classes.paySheetTableCell} align="center">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleEditClick(contract)}
                                            color="primary"
                                        >
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            onClick={() => handleDeleteClick(contract)}
                                            color="error"
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
            <ContractModal
                open={modalOpen}
                onClose={handleCloseModal}
                onSave={handleSaveModal}
                contract={selectedContract}
                operatorId={operatorId}
                isEditing={isEditing}
            />
        </div>
    );
};

export default OperatorContracts;

